import { getConsent } from '../components/CookieConsent';

// Engagement events for the Meta Pixel, so ads can be optimised for people
// who actually stay rather than a PageView for every visit, bounces included.
// Currently just EngagedVisit (custom): on a community page and not a bounce
// — 10s+ on screen, scrolled 25%+, or clicked something (the same rule as
// the admin Page Analytics bounce). Only ever sent for visitors who accepted cookies: the pixel itself only
// loads on consent (CookieConsent.js), and consent is re-checked here so
// nothing is sent if it was declined later. Admin / localhost / automated
// visits are skipped so they don't skew the ads' learning.
const STANDARD_EVENTS = new Set(['Lead', 'CompleteRegistration', 'ViewContent']);

// One pixel serves every community, so every event carries which one:
// content_ids [community id], content_name (its name) and content_category
// (its address, e.g. "London-Theatre-Buddies"). In Meta, a custom conversion
// on CompleteRegistration filtered to content_category = London-Theatre-Buddies
// counts only theatre sign-ups — never golfers'.
export const communityParams = ({ id, title, ref } = {}) => ({
  content_type: 'community',
  ...(id ? { content_ids: [String(id)] } : {}),
  ...(title ? { content_name: String(title) } : {}),
  ...(ref ? { content_category: String(ref) } : {}),
});

export const trackMeta = (event, params = {}, { internal = false } = {}) => {
  try {
    if (internal || typeof window === 'undefined' || !window.fbq) return;
    if (getConsent() !== 'accepted') return;
    window.fbq(STANDARD_EVENTS.has(event) ? 'track' : 'trackCustom', event, params);
  } catch { /* never break the page over tracking */ }
};
